import { FC, SVGProps } from 'react'

import IconShape1 from '@/public/images/genre/shape-1.svg'
import IconShape2 from '@/public/images/genre/shape-2.svg'
import IconShape3 from '@/public/images/genre/shape-3.svg'
import IconShape4 from '@/public/images/genre/shape-4.svg'
import IconShape5 from '@/public/images/genre/shape-5.svg'
import IconShape6 from '@/public/images/genre/shape-6.svg'
import IconShape7 from '@/public/images/genre/shape-7.svg'
import IconShape8 from '@/public/images/genre/shape-8.svg'
import IconShape9 from '@/public/images/genre/shape-9.svg'

import IconShape10 from '@/public/images/genre/shape-10.svg'
import IconShape11 from '@/public/images/genre/shape-11.svg'
import IconShape12 from '@/public/images/genre/shape-12.svg'
import IconShape13 from '@/public/images/genre/shape-13.svg'
import IconShape14 from '@/public/images/genre/shape-14.svg'
import IconShape15 from '@/public/images/genre/shape-15.svg'
import IconShape16 from '@/public/images/genre/shape-16.svg'
import IconShape17 from '@/public/images/genre/shape-17.svg'
import IconShape18 from '@/public/images/genre/shape-18.svg'
import IconShape19 from '@/public/images/genre/shape-19.svg'
import IconShape20 from '@/public/images/genre/shape-20.svg'
import IconShape21 from '@/public/images/genre/shape-21.svg'
import IconShape22 from '@/public/images/genre/shape-22.svg'
import IconShape23 from '@/public/images/genre/shape-23.svg'
import IconShape24 from '@/public/images/genre/shape-24.svg'

import { RoomTag } from '@/types/genre'

export const GENRE_PAGE_LIMIT = 40

// 🔹 Gradient Rhythm: 5-gradient cycle (G1 → G2 → G3 → G4 → G5 → repeat)
export const gradientStyles = [
  {
    primaryGradient: 'linear-gradient(81.25deg, #FFFFCA -0.07%, #FFE1FF 40.77%, #F78AFF 118.81%)',
    overlayGradient: 'linear-gradient(0deg, #D9D9D9, #D9D9D9)',
  },
  {
    primaryGradient: 'linear-gradient(90deg, #F5FFC9 0%, #16E5C6 100%)',
    overlayGradient: 'linear-gradient(90deg, #F5FFC9 0%, #16E5C6 100%)',
  },
  {
    primaryGradient: 'linear-gradient(252.03deg, #415FFB -19.59%, #15FFF7 83.31%)',
    overlayGradient: 'linear-gradient(81.25deg, #FFFFCA -0.07%, #FFE1FF 40.77%, #F78AFF 118.81%)',
  },
  {
    primaryGradient: 'linear-gradient(254.18deg, #FFA05C 8.47%, #FFE5DB 84.96%)',
    overlayGradient: 'linear-gradient(81.25deg, #FFFFCA -0.07%, #FFE1FF 40.77%, #F78AFF 118.81%)',
  },
  {
    primaryGradient: 'linear-gradient(254.18deg, #FAF55A 8.47%, #F6F951 38.99%, #FFFEC9 84.96%)',
    overlayGradient: 'linear-gradient(81.25deg, #FFFFCA -0.07%, #FFE1FF 40.77%, #F78AFF 118.81%)',
  },
]

// 🔹 Shape Rhythm: 24-shape cycle (Shape 1 → Shape 2 → ... → Shape 24 → repeat)
export const shapeIcons: FC<SVGProps<SVGElement>>[] = [
  IconShape1,
  IconShape2,
  IconShape3,
  IconShape4,
  IconShape5,
  IconShape6,
  IconShape7,
  IconShape8,
  IconShape9,
  IconShape10,
  IconShape11,
  IconShape12,
  IconShape13,
  IconShape14,
  IconShape15,
  IconShape16,
  IconShape17,
  IconShape18,
  IconShape19,
  IconShape20,
  IconShape21,
  IconShape22,
  IconShape23,
  IconShape24,
]

export type GenreCardData = {
  name: string
  title: string
  primaryGradient: string
  overlayGradient: string
  Icon: FC<SVGProps<SVGElement>>
}

export function mapTagsToGenres(tags: RoomTag[] | undefined): GenreCardData[] | undefined {
  return tags?.map((tag, index) => ({
    name: tag.name,
    title: tag.translations?.[0]?.name ?? tag.name,
    // 🔹 Dynamic assignment based on index cycling
    primaryGradient: gradientStyles[index % gradientStyles.length].primaryGradient,
    overlayGradient: gradientStyles[index % gradientStyles.length].overlayGradient,
    Icon: shapeIcons[index % shapeIcons.length],
  }))
}
